import {combineReducers} from 'redux-immutable'
import immutable from 'immutable'
import _ from 'lodash'

import socketReducers from './socket/socket.reducer'
import legReducers from './leg/leg.reducer'
import propertyReducers from './properties/properties.reducer'
import transportationReducers from './travel/transportation.reducer'
import travelersReducers from './travelers/travelers.reducer'
import chatReducers from './chat/chat.reducer'
import historyReducers from './history/history.reducer'
import uiStateReducer from './ui/uistate.reducer'
import routerReducer from './services/router/router.reducer'
import {LOAD_INITIAL_DATA, INIT_STATE_ORDER} from './init/initialdata.action'

export const SYNC_IGNORE_KEYS = [
    'uiState',
    'editQueue',
    'chat',
    'initialData',
]

const noopReducer = (state, action) => state

const documentReducer = combineReducers({
    legs: legReducers,
    properties: propertyReducers,
    travelers: travelersReducers,
    transportation: transportationReducers,
    basket: noopReducer,
    purchaseHistory: noopReducer,
    bookingTravelers: noopReducer,
})

const indexReducer = combineReducers({
    document: documentReducer,
    uiState: uiStateReducer,
    chat: chatReducers,
    history: historyReducers,

    socket: noopReducer,
    initialData: noopReducer,
    clientSessionId: noopReducer,
    lunaTrip: noopReducer,
    clonedTrip: noopReducer,
    gitHash: noopReducer,
    travelerGuid: noopReducer,
    currentUser: noopReducer,
    revision: noopReducer,
    route: routerReducer,
})

const plannerApp = (state, action) => {
    switch (action.type) {
        case LOAD_INITIAL_DATA:
            state = state.setIn(['document', 'properties', 'itineraryGuid'], action.data.itinerary.guid)
            state = state.setIn(['document', 'properties', 'tripGuid'], action.data.trip.guid)
            state = state.setIn(['document', 'properties', 'initStep'], INIT_STATE_ORDER[0])
            state = state.setIn(['document', 'properties', 'tripTitle'], action.data.trip.name)
            state = state.setIn(['document', 'travelers'], immutable.fromJS(action.data.travelers))
            state = state.set('travelerGuid', action.data.travelerGuid)
            state = state.set('currentUser', action.data.traveler)

            if (action.data.isLunaTrip) {
                state = state.setIn(['lunaTrip', 'isLunaTrip'], action.data.isLunaTrip)
                state = state.setIn(['lunaTrip', 'trip'], immutable.fromJS(action.data.lunatrip))
            }

            if (action.data.itinerary.luna_trip) {
                state = state.setIn(['lunaTrip', 'fromLunaTrip'], action.data.itinerary.luna_trip)
            }

            state = state.setIn(['clonedTrip', 'tripGuid'], action.data.cloned_trip_guid)
            state = state.setIn(['clonedTrip', 'itineraryGuid'], action.data.cloned_itinerary_guid)

            if (window.payload.action === 'INITIALIZE') {
                state = state.setIn(['uiState', 'socketLoaded'], true)
            }

            return state
        case 'RESET':
            state = state.setIn(['uiState', 'socketLoaded'], true)
            let incoming = _.pick(action, ['clientSessionId', 'gitHash', 'revision', 'document'])
            let newState = _.merge(state.toJS(), incoming)

            // update socket has loaded to true
            return immutable.fromJS(newState)
    }

    state = socketReducers(state, action)

    return indexReducer(state, action)
}

export default plannerApp
